import { DataEntry } from 'models/data';
import { IntlShape } from 'react-intl';
import { getWeek, getYear } from 'date-fns';

export const getLabelForDatapoint = (entry: DataEntry, intl: IntlShape) => {
  const attributeNames = Object.getOwnPropertyNames(entry.attributes);
  if (attributeNames.length === 0) return '';
  const timeKey = attributeNames[0];
  const fromDate = new Date(entry.dateRanges[timeKey].fromDate);
  if (entry.attributes.timeDate) {
    return intl.formatDate(fromDate);
  }
  if (entry.attributes.timeYearWeek) {
    const week = getWeek(fromDate);
    const calendarWeekAbbr = intl.formatMessage({
      id: 'calendarweek',
    });
    const year = getYear(fromDate);
    return `${calendarWeekAbbr}${week} ${year}`;
  }
  if (entry.attributes.timeYearMonth) {
    return intl.formatDate(fromDate, { year: 'numeric', month: 'long' });
  }
  if (entry.attributes.timeYear) {
    return entry.attributes.timeYear;
  }
  return '';
};
